import React from 'react'
import { cn } from '../../utils/cn'

interface FieldProps {
  required?: boolean
  fit?: boolean
  extra?: React.ReactElement
  ctrlClassName?: string
  helpText?: React.ReactElement
  label?: React.ReactElement
  error?: React.ReactElement
  component?: React.ReactElement
  children?: React.ReactNode
}

const Field: React.FC<FieldProps> = ({ component, children, ctrlClassName, label, helpText, fit, required, error }) => {
  const classNames = cn(
    'e-field',
    {
      fit,
      error,
    }
  )

  const ctrlClassNames = cn(
    'e-ctrl',
    ctrlClassName
  )

  const child = component
    ? React.cloneElement(component, {
      className: cn(
        component.props.className,
      )
    })
    : null

  const allowHtmlFor = component ? component.props.type !== 'checkbox' : false

  return (
    <div className={classNames}>
      {(label || helpText) && (
        <div className='e-info'>
          {label && (
            <label className='e-label'>
              {label}
              {required && <span className='e-asterisk'>*</span>}
            </label>
          )}

          {helpText && (
            <div className='e-help'>{helpText}</div>
          )}
        </div>
      )}

      <div className={ctrlClassNames}>
        {child}
        {children}
      </div>

      {error && (
        <div className='e-error'>{error}</div>
      )}
    </div>
  )
}

export default Field